export const useUtil = () => {
  const openModal = () => {
    window.parent.postMessage({ action: 'MODAL_OPEN' }, getPoratlHost() as string);
  };

  const closeModal = () => {
    window.parent.postMessage({ action: 'MODAL_CLOSE' }, getPoratlHost() as string);
  };

  return {
    openModal,
    closeModal
  };
};

export const getPoratlHost = () => {
  const PortalURL = document.referrer;
  if (PortalURL) {
    const url = new URL(PortalURL);
    return url.origin;
  } else return document.location.href;
};
